import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Item from './components/Item';
import { DevicesContext, IDevicesContext } from '../../../../devicesState/devicesContext';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { devices } = useContext<IDevicesContext>(DevicesContext);

	const hardwareIdHeadingClasses = classNames(style.hardwareId, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const terminalIdHeadingClasses = classNames(style.terminalId, style.heading);
	const tableNumberHeadingClasses = classNames(style.tableNumber, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={hardwareIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="hardwareIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantAddressLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={terminalIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="terminalIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={tableNumberHeadingClasses}
					translationNameSpace="listing"
					translationKey="tableNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{devices.items.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
